import Joi from 'joi';

export const textToVoiceResultSchema = Joi.object({
  audioBuffer: Joi.string().required(),
});

export interface ITextToVoiceResult {
  audioBuffer: string;
}
